<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<main class="harness">
  <div class="between"><ng-container *ngTemplateOutlet="contentTemplate" /></div>
</main>

<ng-template #contentTemplate><ng-content /></ng-template>
